import { render, staticRenderFns } from "./TransportOrder.vue?vue&type=template&id=39cf7015&"
import script from "./TransportOrder.vue?vue&type=script&lang=js&"
export * from "./TransportOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports